import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  SubledgerService,
  SubledgerContainerModel,
  Pagination,ApiVisa
} from 'blg-akaun-ts-lib';
import { ReplaySubject, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { SubSink } from 'subsink2';

@Component({
  selector: 'app-select-subledger',
  templateUrl: './select-subledger.component.html',
  styleUrls: ['./select-subledger.component.scss']
})
export class SelectSubledgerComponent implements OnInit, OnDestroy {
  @Input() apiVisa: ApiVisa;
  @Input() subledger: FormControl;
  @Input() ledgerSelectedGuid: string;
  @Output() subledgerChange = new EventEmitter<FormControl>();
  @Output() subledgerSelected = new EventEmitter<SubledgerContainerModel>();
  private subs = new SubSink();
  selectedSubledger = new SubledgerContainerModel();
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<SubledgerContainerModel[]> = new ReplaySubject<SubledgerContainerModel[]>(1);
  subledgerList: SubledgerContainerModel[] = [];
  subledgers: any = [];
  selectedLedger = '';
  serverSideFiltering = new FormControl();
  protected _onDestroy = new Subject<void>();
  constructor( private subledgerService: SubledgerService,
  ) {}

  ngOnInit() {
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.SubledgerFiltering();
    });

    // load the initial subledger list
    this.getAllSubledgers();
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterSubledger(resolve)});
  }

  filterSubledger(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.subledgerList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.subledgerList.filter(c => c.bl_fi_sub_ledger_hdr.gl_code_1.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }

  }

  getAllSubledgers() {


      //empty the prev list when selected ledger changed
      this.subledgerList = [];
      this.subledgers = [];
      this.filteredOptions$.next(this.subledgers.slice());
      //if there is a selected ledger
      if (this.ledgerSelectedGuid) {


        let subledgerGuidsList = [];

              let paging = new Pagination();
              paging.limit = 1000;
              paging.conditionalCriteria = [];
              paging.conditionalCriteria.push
              ({ columnName: 'ledger_hdr_guid', operator: '=', value: this.ledgerSelectedGuid });

              this.subledgerService.getByCriteria(paging, this.apiVisa).subscribe(subledger => {
                subledger.data.forEach((data) => {
                  this.subledgers.push(data);
                  this.subledgerList.push(data);
                });

                // sorting
                const sorted = this.subledgers.sort((a, b) => (a.bl_fi_sub_ledger_hdr.gl_code_1 < b.bl_fi_sub_ledger_hdr.gl_code_1 ? -1 : 1));
                //fill the drop down
                this.filteredOptions$.next(this.subledgers.slice());
              })

      }



  }

  SubledgerFiltering() {
    if (!this.subledgers) {
      return;
    }
    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search) {
      this.filteredOptions$.next(this.subledgers.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the subledgers
    this.filteredOptions$.next(
      this.subledgers.filter((option) =>
        (option.bl_fi_sub_ledger_hdr.gl_code_1 ?
          option.bl_fi_sub_ledger_hdr.gl_code_1.toLowerCase().indexOf(search) > -1 : null) ||
        (option.bl_fi_sub_ledger_hdr.name ?
          option.bl_fi_sub_ledger_hdr.name.toLowerCase().indexOf(search) > -1 : null))
    );
  }

  onSelect(subledgerGuid: string) {
    if (subledgerGuid) {
      this.subledger.patchValue(subledgerGuid);
      this.selectedSubledger = this.subledgerList.find(s => s.bl_fi_sub_ledger_hdr.guid === subledgerGuid);
      this.subledgerSelected.emit(this.selectedSubledger);
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
